import { createAction } from 'redux-actions';

const MODULE = 'app/entities';

const ADD_ENTITIES = `${MODULE}/ADD_ENTITIES`;
const DELETE_ENTITIES = `${MODULE}/DELETE_ENTITIES`;

export const addEntities = createAction(ADD_ENTITIES);
export const deleteEntities = createAction(DELETE_ENTITIES);
